<template>
  <el-upload v-bind="$attrs" v-on="$listeners" :headers="headers">
    <slot/>
  </el-upload>
</template>

<script>

export default {
  name: 'JmUpload',

  computed: {
    headers() {
      return {
        'x-site-name': process.env.VUE_APP_SITE_NAME || 'fib',
        'x-jwt-token': this.$lockr.get('jwt', null),
      };
    }
  },
};
</script>
